import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SentEmail from './icon-sent-email.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SentEmail {...validProps} />;
}
SvgComponent.iconName = 'iconSentEmail';

export const SentEmailIcon = svgIconWrapper(SvgComponent);
